module.exports = __webpack_public_path__ + "Roboto-BoldItalic.355e388740673054493c.woff2";


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/roboto-fontface/fonts/Roboto/Roboto-BoldItalic.woff2
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-BoldItalic.woff2
// module chunks = 34